module.exports = {
	"ha": "iha",
	"id": 5.3,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Interior Health by Age Category, Year Ending 2018 Q2 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 84.84848484848484,
						"dataLabels": {
							"enabled": true,
							"format": "28",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 69.6969696969697,
						"dataLabels": {
							"enabled": true,
							"format": "23",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": true,
							"format": "22",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 63.63636363636363,
						"dataLabels": {
							"enabled": true,
							"format": "21",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 45.45454545454545,
						"dataLabels": {
							"enabled": true,
							"format": "15",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.55072463768117,
						"dataLabels": {
							"enabled": true,
							"format": "68",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 82.6086956521739,
						"dataLabels": {
							"enabled": true,
							"format": "57",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 76.81159420289855,
						"dataLabels": {
							"enabled": true,
							"format": "53",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 65.21739130434783,
						"dataLabels": {
							"enabled": true,
							"format": "45",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 50.72463768115942,
						"dataLabels": {
							"enabled": true,
							"format": "35",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 97.79411764705883,
						"dataLabels": {
							"enabled": true,
							"format": "133",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": true,
							"format": "102",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 69.11764705882352,
						"dataLabels": {
							"enabled": true,
							"format": "94",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 61.029411764705884,
						"dataLabels": {
							"enabled": true,
							"format": "83",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 41.911764705882355,
						"dataLabels": {
							"enabled": true,
							"format": "57",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.30508474576271,
						"dataLabels": {
							"enabled": true,
							"format": "406",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 82.08232445520581,
						"dataLabels": {
							"enabled": true,
							"format": "339",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 78.93462469733656,
						"dataLabels": {
							"enabled": true,
							"format": "326",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 74.09200968523002,
						"dataLabels": {
							"enabled": true,
							"format": "306",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 58.111380145278446,
						"dataLabels": {
							"enabled": true,
							"format": "240",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -15.151515151515149,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.85714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.347826086956519,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.545454545454541,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -28.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.449275362318836,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.176470588235293,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.017543859649122,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -15.094339622641506,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -22.22222222222222,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -2.2058823529411797,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -23.308270676691734,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.843137254901967,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.702127659574469,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -31.32530120481928,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.6949152542372836,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.50246305418719,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.834808259587019,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.134969325153373,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -21.568627450980394,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=33"
			},
			{
				"x": 9,
				"text": "30–39<br>n=69"
			},
			{
				"x": 15,
				"text": "40–49<br>n=136"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=413"
			}
		],
		"dataTable": {
			"< 30": [
				33,
				28,
				23,
				22,
				21,
				15
			],
			"30–39": [
				69,
				68,
				57,
				53,
				45,
				35
			],
			"40–49": [
				136,
				133,
				102,
				94,
				83,
				57
			],
			"≥ 50": [
				413,
				406,
				339,
				326,
				306,
				240
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_iha_5_3.json
// module id = 235
// module chunks = 0